import {
  Field,
  Form,
  PrimaryButton,
  Space,
  TertiaryButton,
} from '@procurify/ui'
import { type FormikHelpers } from 'formik'

import { checkIsApprovalPoolLikeUseCase } from '@webapp/core/business-logic/use-cases/CheckIsApprovalPoolLike'
import { type ApprovalPoolLike } from '@webapp/core/interfaces/components/ApprovalPoolLike'
import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ApprovalPoolLabel } from '../ApprovalPoolLabel'
import { UserLabel } from '../UserLabel'

export interface IApprovalReminderFormProps {
  recipient: UserLike | ApprovalPoolLike
  onCancel: () => void
  onSubmit: (
    values: ApprovalReminderFormSchema,
    formikHelpers: FormikHelpers<ApprovalReminderFormSchema>
  ) => void
}

export interface ApprovalReminderFormSchema {
  message: string
}

const INITIAL_FORM_VALUES: ApprovalReminderFormSchema = {
  message: '',
}

export const ApprovalReminderForm = ({
  recipient,
  onCancel,
  onSubmit,
}: IApprovalReminderFormProps) => {
  const intl = useProcurifyIntl()

  return (
    <Form<ApprovalReminderFormSchema>
      initialValues={INITIAL_FORM_VALUES}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form.Content>
          <Space>
            <Field
              label={intl.formatMessage(messages.recipientLabel)}
              layout='horizontal'
            >
              {checkIsApprovalPoolLikeUseCase(recipient) ? (
                <ApprovalPoolLabel
                  level={recipient.level}
                  groupName={recipient.groupName}
                  members={recipient.members}
                />
              ) : (
                <UserLabel user={recipient} />
              )}
            </Field>

            <Form.TextField
              id='comment'
              label={intl.formatMessage(messages.commentLabel)}
              name='message'
              multiline
              minRows={3}
              placeholder={intl.formatMessage(messages.commentPlaceholder)}
            />

            <Space.Divider />

            <Space direction='horizontal' justify='end'>
              <TertiaryButton type='button' onClick={onCancel}>
                {intl.formatMessage(messages.cancelButtonText)}
              </TertiaryButton>
              <PrimaryButton type='submit' disabled={isSubmitting}>
                {intl.formatMessage(messages.sendReminderButtonText)}
              </PrimaryButton>
            </Space>
          </Space>
        </Form.Content>
      )}
    </Form>
  )
}
